/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useEffect, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import data from './csvjson';
import moment from 'moment';

function App() {

  const [filteredValue, setFilteredValue] = useState<any>();

  const loadData = (city: string) => {
    console.log((moment(new Date()).format('YYYY-MM-DD')).toString())
    const loaded = data.find((item: any) => {
      return item.city === city && item.date === (moment(new Date()).format('YYYY-MM-DD')).toString();
    });
    console.log(loaded);
    setFilteredValue(loaded);
  }

  useEffect(() => {
    loadData('Amman');
  },[]);
  
  const timeFormat = (time: string) => {
    return moment(time,["HH.mm.ss"]).format("h:mm A");
  }

  const timeFormatAdd = (time: string) => {
    return moment(time,["HH.mm.ss"]).add({minutes: 30}).format("h:mm A");
  }

  return (
    <div className="App">
      <section className='prayer-times'>
      {/* <label htmlFor="prayer-times-select">Cities:</label> */}
      <select id='prayer-times-select' title='Cities' onChange={(e) => loadData(e.target.value) }>
    <option key={'Dubai'} value={'Dubai'}>
      {'Dubai'}
    </option> 
    <option key={'Abu dhabi'} value={'Abu dhabi'}>
      {'Abu dhabi'}
    </option> 
    <option key={'Sharjah'} value={'Sharjah'}>
      {'Sharjah'}
    </option> 
    <option key={'Ras alkhaima'} value={'Ras alkhaima'}>
      {'RAS Al Khaimah'}
    </option> 
    <option key={'Amman'} value={'Amman'}>
      {'Amman'}
    </option> 
    <option key={'Aqaba'} value={'Aqaba'}>
      {'Aqaba'}
    </option> 
    <option key={'Cairo'} value={'Cairo'}>
      {'Aqaba'}
    </option>   
    <option key={'Jeddah'} value={'Jeddah'}>
      {'Jeddah'}
    </option>
    <option key={'Riyadh'} value={'Riyadh'}>
      {'Riyadh'}
    </option>
    <option key={'Khobar'} value={'Khobar'}>
      {'Khobar'}
    </option>
    <option key={'Makkah'} value={'Makkah'}>
      {'Makkah'}
    </option>
    <option key={'Madina'} value={'Madina'}>
      {'Madinah'}
    </option>
    <option key={'Dammam'} value={'Dammam'}>
      {'Dammam'}
    </option> 
    <option key={'Kuwait'} value={'Kuwait'}>
      {'Kuwait'}
    </option> 
    <option key={'Doha'} value={'Doha'}>
      {'Doha'}
    </option>   
    <option key={'Beirut'} value={'Beirut'}>
      {'Beirut'}
    </option>   
    <option key={'Muscat'} value={'Muscat'}>
      {'Muscat'}
    </option>   
    <option key={'Manama'} value={'Manama'}>
      {'Manama'}
    </option>   
    <option key={'Erbil'} value={'Erbil'}>
      {'Erbil'}
    </option>
    </select>
    <div className='cards'>
    <div style={{ 'backgroundColor': '#fafafa' }} className='card'>
      <h2>FAJR</h2>
       {
         <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold' }}>Start: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.fajr}> {' '+timeFormat(filteredValue?.fajr)}</div> </span>
       }
      {
         <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold', marginTop: '8px' }}>Iqamah: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.fajr}> {' '+timeFormatAdd(filteredValue?.fajr)}</div> </span>
       }
    </div>
    <div style={{ 'backgroundColor': '#fff' }} className='card'>
    <h2>DUHUR</h2>
       {
           <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold' }}>Start: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.duhur}> {' '+timeFormat(filteredValue?.duhur)}</div> </span>
        }
        {
           <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold', marginTop: '8px' }}>Iqamah: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.duhur}> {' '+timeFormatAdd(filteredValue?.duhur)}</div> </span>
        }
    </div>
    <div style={{ 'backgroundColor': '#fafafa' }} className='card'>
    <h2>ASR</h2>
       {
          <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold' }}>Start: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.asr}> {' '+timeFormat(filteredValue?.asr)}</div> </span>
        }
        {
          <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold', marginTop: '8px' }}>Iqamah: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.asr}> {' '+timeFormatAdd(filteredValue?.asr)}</div> </span>
        }
    </div>
    <div style={{ 'backgroundColor': '#fff' }} className='card'>
    <h2>MAGHRIB</h2>
       {
          <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold' }}>Start: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.maghrib}> {' '+timeFormat(filteredValue?.maghrib)}</div> </span>
        }
        {
          <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold', marginTop: '8px' }}>Iqamah: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.maghrib}> {' '+timeFormatAdd(filteredValue?.maghrib)}</div> </span>
        }
    </div>
    <div style={{ 'backgroundColor': '#fafafa' }} className='card'>
    <h2>ISHA</h2>
       {
          <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold' }}>Start: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.isha}> {' '+timeFormat(filteredValue?.isha)}</div> </span>
        }
        {
          <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold', marginTop: '8px' }}>Iqamah: <div style={{ marginLeft: '8px', 'color': '#FF9822' }} key={filteredValue?.isha}> {' '+timeFormatAdd(filteredValue?.isha)}</div> </span>
        }
    </div>
    {/* <div style={{ 'backgroundColor': '#FF9822' }} className='card'>
    <h2>JUMMAH</h2>
       {
          <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold' }}>Start: <div style={{ marginLeft: '8px', 'color': '#FFF' }}> {' '+timeFormat('11:45:00')}</div> </span>
        }
        {
          <span style={{color: '#5D2B00', display: 'flex', fontWeight: 'bold', marginTop: '8px' }}>Iqamah: <div style={{ marginLeft: '8px', 'color': '#FFF' }}> {' '+timeFormatAdd('11:45:00')}</div> </span>
        }
    </div> */}
    </div>
      </section>
    </div>
  );
}

export default App;